<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="/">Full Stack Message Board</a>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
